import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { ToastContainer } from 'react-toastify';
import styles from './App.module.scss';
import Routes from '../Routes';
import Container from '../Container';
import 'react-toastify/dist/ReactToastify.css';
import P from '../../components/Typography/P';
import ScrollToTop from '../../utils/scrollToTop';
import { useLocation } from 'react-router';

// const button = () => <Button name="I understand" small className={styles.buttonClassesCooke} />;

// const button = () => <Button name="I understand" small className={styles.buttonClassesCooke} />;

const App = () => {
  const usePlo5Query = () => (
    new URLSearchParams(useLocation().search).get('isPlo5')
  );

  sessionStorage.setItem('isPlo5', usePlo5Query());
  window.dispatchEvent(new Event('storage'));

  return (
    <div className={styles.app}>
      <CookieConsent
        contentClasses={styles.contentWrapper}
        buttonWrapperClasses={styles.buttonWrapper}
        buttonClasses={styles.buttonClassesCooke}
      >
        <P>This website uses cookies to enhance the user experience.</P>
      </CookieConsent>
      <Container>
        <ScrollToTop />
        <Routes />
        <ToastContainer />
      </Container>
    </div>
  );
};

export default App;
